<div class="card"
  [ngClass]="[ size, (disabled || buttonDisabled) ? 'disabled' : '', showOverlay ? 'highlight-card' : '']" tabindex="0">
  <div *ngIf="showOverlay" class="highlight-overlay"> {{ overlayMsg }} </div>
  <b3-card itemTitle="{{ title }}">
    <b3-card-body>
      <p class="card-content" [innerHTML]="content"></p>
      <div [class]="buttonCenter ? 'button-wrapper-center' : 'button-wrapper'">

        <b3-button
          [class]="[!buttonDisabled ? 'buttonIcon':'buttonDisabled', leftRightPadding > 0 ? 'px-'+leftRightPadding:'']"
          label="{{ buttonTitle }}" status="primary" (onClick)="onClick(href)"
          [disabled]="disabled || showOverlay || buttonDisabled"
          [style.pointer-events]="!buttonDisabled ? 'auto':'none'">
        </b3-button>
        <img [class]="!buttonDisabled ? 'button-icon':'invisivel'" [src]="disabled ? disabledIcon : icon" alt="icon" />

      </div>
    </b3-card-body>
  </b3-card>
</div>